export default $axios => ({
  fetchCurrent(params) {
    return $axios.$get('/v2/commercial-operation', { params })
  },

  fetchSelection(params) {
    return $axios.$get('/v2/commercial-operation/selection', { params })
  },

  getServiceName: () => 'commercialOperationService',
})
